import * as z from "zod";
//#region src/__generated__/external/payment/zod/externalPaymentViewSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const externalPaymentViewSchema = z.object({
	canNotify: z.boolean().nullish().describe("Можно ли уведомить об оплате"),
	canUploadProof: z.boolean().nullish().describe("Можно ли загрузить/заменить подтверждение"),
	invoiceAmount: z.number().nullish().describe("Стоимость по счёту, ₽"),
	invoiceNumber: z.string().nullish().describe("Номер счёта"),
	invoiceReceived: z.boolean().nullish().describe("Счёт получен (вкладка «Оплата» видна)"),
	invoiceSentAt: z.iso.datetime().nullish().describe("Дата выставления счёта"),
	proofFileId: z.uuid().nullish().describe("Идентификатор файла подтверждения"),
	proofFileName: z.string().nullish().describe("Имя файла подтверждения"),
	proofUploaded: z.boolean().nullish().describe("Подтверждение загружено")
}).describe("Данные оплаты по заявке (внешний контур, для заявителя)");
//#endregion
//#region src/__generated__/external/payment/zod/deleteProofSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteProofPathIdSchema = z.uuid();
const deleteProofStatus200Schema = externalPaymentViewSchema.describe("Данные оплаты по заявке (внешний контур, для заявителя)");
const deleteProofResponseSchema = deleteProofStatus200Schema;
//#endregion
//#region src/__generated__/external/payment/zod/get2Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const get2PathIdSchema = z.uuid();
const get2Status200Schema = externalPaymentViewSchema.describe("Данные оплаты по заявке (внешний контур, для заявителя)");
const get2ResponseSchema = get2Status200Schema;
//#endregion
//#region src/__generated__/external/payment/zod/notifyPaidSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const notifyPaidPathIdSchema = z.uuid();
const notifyPaidStatus200Schema = externalPaymentViewSchema.describe("Данные оплаты по заявке (внешний контур, для заявителя)");
const notifyPaidResponseSchema = notifyPaidStatus200Schema;
//#endregion
//#region src/__generated__/external/payment/zod/uploadProofSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uploadProofPathIdSchema = z.uuid();
const uploadProofStatus200Schema = externalPaymentViewSchema.describe("Данные оплаты по заявке (внешний контур, для заявителя)");
const uploadProofResponseSchema = uploadProofStatus200Schema;
const uploadProofDataSchema = z.object({ file: z.instanceof(File) }).optional();
//#endregion
export { notifyPaidPathIdSchema as a, get2PathIdSchema as c, deleteProofPathIdSchema as d, deleteProofResponseSchema as f, uploadProofStatus200Schema as i, get2ResponseSchema as l, externalPaymentViewSchema as m, uploadProofPathIdSchema as n, notifyPaidResponseSchema as o, deleteProofStatus200Schema as p, uploadProofResponseSchema as r, notifyPaidStatus200Schema as s, uploadProofDataSchema as t, get2Status200Schema as u };

//# sourceMappingURL=uploadProofSchema.js.map